import LaneHeader from "./Lane/LaneHeader";
import LaneFooter from "./Lane/LaneFooter";
import Card from "./Card";
import Loader from "./Loader";
import NewLaneForm from "./NewLaneForm";
import NewCardForm from "./NewCardForm";
import AddCardLink from "./AddCardLink";
import NewLaneSection from "./NewLaneSection";
import { GlobalStyle, Section, BoardWrapper, ScrollableLane } from "../styles/Base";

export default {
  GlobalStyle,
  BoardWrapper,
  Loader,
  ScrollableLane,
  LaneHeader,
  LaneFooter,
  Section,
  NewLaneForm,
  NewLaneSection,
  NewCardForm,
  Card,
  AddCardLink,
};
